import * as styles from "./PopoverArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverArrowProps } from "./Popover.types";

export function PopoverArrow({
  className,
  ...props
}: PopoverArrowProps): JSX.Element {
  return (
    <BasePopover.Arrow
      data-slot="popover-arrow"
      className={clsx(styles.arrow, className)}
      {...props}
    />
  );
}
